module.exports = __webpack_public_path__ + "img/menu.e823597.svg";